import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    /* {
      path: '/',
      name: 'home',
      component: Home,
    }, */
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/map',
      name: 'map',
      // route level code-splitting
      // this generates a separate chunk (map.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "map" */ './views/Map.vue'),
    },
    {
      path: '/route',
      name: 'route',
      component: () => import('./views/Route.vue'),
    },
    {
      path: '/destination',
      name: 'destination',
      component: () => import('./views/Destination.vue'),
    },
    {
      path: '/route/:id',
      name: 'route_detail',
      component: () => import('./views/RouteDetail.vue'),
    },
    {
      path: '/',
      name: 'start_page',
      component: () => import('./views/Start.vue'),
    },
  ],
});
